module.exports = window.dnn.Sites.CommonComponents;